import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';

import { FlyoutOpenState } from '../../../Constants';

import rightRailService, { RightRailTab } from '../../services/RightRailService';

import Flyout from '../tabbedFlyout/Flyout';
import QuestionFlyout from '../tabbedFlyout/QuestionFlyout';

import '../../../css/RightRail.scss';

/**
 * Unified right-edge rail for interactive activities. One panel, one tab strip.
 * The questions flyout and the child item's teacher tabs (including custom
 * teacher tabs) share that strip so neither covers the other.
 */
const RightRail = observer(({ hostedFlyout, question } = {}) => {
  const {
    navMenuManager
  } = useContext(MobXProviderContext);

  const hostedLessonElementId = hostedFlyout?.lessonElementId || null;
  // Set before children render so the questions tab reads the current hosted flyout.
  rightRailService.registerHostedFlyout(hostedLessonElementId);

  useEffect(() => () => {
    rightRailService.registerHostedFlyout(null);
  }, []);

  const selectedTab = rightRailService.selectedTab;
  const isOpen = rightRailService.isOpen;
  const flyoutState = hostedLessonElementId
    ? navMenuManager.getFlyoutOpenState(hostedLessonElementId)
    : null;

  return (
    <div className={classNames('right-rail', {
      open: isOpen,
      interactive: selectedTab === RightRailTab.INTERACTIVE,
      flyout: selectedTab === RightRailTab.FLYOUT,
      wide: selectedTab === RightRailTab.FLYOUT && flyoutState?.open === FlyoutOpenState.OPEN_WIDE,
      wider: selectedTab === RightRailTab.FLYOUT && flyoutState?.open === FlyoutOpenState.OPEN_WIDER
    })}>
      <div className='right-rail-tabs' role='tablist'>
        <QuestionFlyout
          isActivity={question.isActivity}
          lessonElementId={question.lessonElementId}
          showQuestionBanner={question.showQuestionBanner}
          variant='tabs' />
        {hostedFlyout && (
          <Flyout
            embedSide='right'
            flyoutSide={hostedFlyout.flyoutSide}
            isActivity={hostedFlyout.isActivity}
            isScoring={hostedFlyout.isScoring}
            lessonElementId={hostedFlyout.lessonElementId}
            variant='tabs' />
        )}
      </div>
      <div
        className='right-rail-panel'
        data-ignore={isOpen ? undefined : '1'}
        id='right-rail-panel'>
        {isOpen && selectedTab === RightRailTab.INTERACTIVE && (
          <QuestionFlyout
            isActivity={question.isActivity}
            lessonElementId={question.lessonElementId}
            showQuestionBanner={question.showQuestionBanner}
            variant='panel' />
        )}
        {isOpen && selectedTab === RightRailTab.FLYOUT && hostedFlyout && (
          <Flyout
            embedSide='right'
            flyoutSide={hostedFlyout.flyoutSide}
            isActivity={hostedFlyout.isActivity}
            isScoring={hostedFlyout.isScoring}
            lessonElementId={hostedFlyout.lessonElementId}
            variant='panel' />
        )}
      </div>
    </div>
  );
});

export default RightRail;
